import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DraftItemState {
  item: unknown;
}

const initialState: DraftItemState = {
  item: null,
};

export const draftItemSlice = createSlice({
  name: 'draftItem',
  initialState,
  reducers: {
    saveDraft(state, action: PayloadAction<unknown>) {
      state.item = action.payload;
    },
    clearDraft(state, _action: PayloadAction<void>) {
      state.item = null;
    },
  },
});

export const {
  saveDraft,
  clearDraft,
} = draftItemSlice.actions;

export default draftItemSlice.reducer;
